<template>
    <div class="display" :class="{selected: selected}" @click="onDisplaySelected()">
        <div class='display-header'>
            <div class='display-status'>
                <span v-for="infopoint in display.infopoints" :key="'ip-icon-'+ infopoint.infopointId">
                    <b-icon v-if="getInfopointStatus(infopoint)=='ONLINE'" icon="check-square-fill" scale='1' variant="success" :title="$t('infopoints.states.ONLINE')"></b-icon>
                    <b-icon v-if="getInfopointStatus(infopoint)=='OFFLINE-1'" icon="exclamation-square-fill" scale='1' variant="warning" :title="$t('infopoints.states.OFFLINE-1')"></b-icon>
                    <b-icon v-if="getInfopointStatus(infopoint)=='OFFLINE-2'" icon="dash-square-fill" scale='1' variant="danger" :title="$t('infopoints.states.OFFLINE-2')"></b-icon>
                    <b-icon v-if="getInfopointStatus(infopoint)=='UNKNOWN'" icon="question-square-fill" scale='1' variant="secondary" :title="$t('infopoints.states.UNKNOWN')"></b-icon>
                </span>
            </div>
            <div class='display-id'>
                {{ getDisplayLabel(display) }}
            </div>
        </div>
        <div v-for="infopoint in display.infopoints" :key="'ip-'+ infopoint.infopointId" class='display-screen'>
            <img :src="screenshot(infopoint)" :title="infopoint.infopointLabel" />
        </div>
        
        <div v-if="!display.infopoints || display.infopoints.length == 0" class='display-screen'>
            {{ display.displayId }}
        </div>
    </div>
</template>

<script>
import terminalView from '@/store/terminals/terminalView';

export default {
	name: 'TerminalDisplay',
    props: ['display'],
    data() {
        return {
            notFoundImage: "/traveller-ui/static/traveller/img/not-found-480x270.png",
        }
    },
    computed: {
        selected() {
            return this.$store.state.terminalView.selectedDisplay &&
                this.$store.state.terminalView.selectedDisplay.displayId == this.display.displayId;
        }
    },
    methods: {
        getInfopointStatus(infopoint) {
            var status = 'UNKNOWN';
            if (infopoint.statusTimestamp) {
                var now = new Date();
                var sd = Date.parse(infopoint.statusTimestamp);

                var diff = now - sd;
                var limit1 = 1000 * 60 * 60;    // 1 h
                var limit2 = limit1 * 12 ;      // 12 h

                if (diff < limit1) status = "ONLINE";
                if (diff > limit1) status = "OFFLINE-1";
                if (diff > limit2) status = "OFFLINE-2";
            }
            return status;
        },
        onDisplaySelected() {
            this.$store.commit('terminalView/setSelectedDisplay', this.display);
            this.$store.dispatch('terminalView/getSelectedDisplayAnnouncements');
        },
        screenshot(infopoint){
             return (infopoint && infopoint.screenshot) ? infopoint.screenshot : this.notFoundImage ;
        },
        getDisplayLabel(display){
            let label = display.displayId;

            if( (display.presentationType == 'platformdisplay' || display.presentationType == 'driverdisplay') && display.platform && display.platform.trim().length > 0)
                label =  display.platform;

            if(display.shortName)
                 label =  display.shortName;

            return label;
        }

    },
    created() {
		if (!this.$store.state.terminalView) {
            this.$store.registerModule("terminalView", terminalView);
        }
    }
};
</script>
